export default "__VITE_ASSET__881e551a__"